import { useCallback } from "react";

import { Action, Stack } from "types/generated";
import useTypedContext from "hooks/useTypedContext";
import useAacFlags from "hooks/useAacFlags";
import { AccountContext } from "views/AccountWrapper";
import { hasAtLeastOneRequiredAction } from "utils/access";
import { AccountViewer } from "components/form/graphql/types";

import useHasStackWriteAccess from "./useHasStackWriteAccess";

const DELETE_CONFIG_ACCESS_TYPES = [Action.StackDeleteConfig];

const hasDeleteConfigAccess = (viewer: AccountViewer, spaceId: string) =>
  hasAtLeastOneRequiredAction(DELETE_CONFIG_ACCESS_TYPES, viewer, spaceId);

const useCanDeleteStackConfig = (): ((stack: Stack) => boolean) => {
  const hasStackWriteAccess = useHasStackWriteAccess();
  const { viewer } = useTypedContext(AccountContext);
  const { customAccessRoles } = useAacFlags();

  return useCallback(
    (stack: Stack) => {
      if (hasStackWriteAccess(stack)) {
        return true;
      }

      if (
        customAccessRoles &&
        hasDeleteConfigAccess(viewer, stack.spaceDetails?.id || stack.space)
      ) {
        return true;
      }

      return false;
    },
    [hasStackWriteAccess, customAccessRoles, viewer]
  );
};

export default useCanDeleteStackConfig;
